import { Skeleton } from 'antd';

function IdeaEvaluateSkeleton() {
  return (
    <div className="p-4">
      <Skeleton active />
    </div>
  );
}

export default IdeaEvaluateSkeleton;
